export default __webpack_public_path__ + "static/media/mockupWeb4.bb7f0b03.jpg";